import React, { FC, Suspense } from "react";
import Layout from "../components/Layout";
import AssetValue from "../components/AssetValue";
import AssetChange from "../components/AssetChange";
import SkeletonLarge from "../components/SkeletonLarge";
import View from "../components/View";
import { ReactComponent as VertDivider } from "../assets/svg/vert-divider.svg";
import { ReactComponent as Divider } from "../assets/svg/divider.svg";
import PortfolioLine from "../components/charts/PortfolioLine";
import DailyBar from "../components/charts/DailyBar";
import WorthLine from "../components/charts/WorthLine";
import DailyLine from "../components/charts/DailyLine";
import Dropdown from "../components/Dropdown";

const AssetDonut = React.lazy(() => import("../components/AssetDonut"));
const AssetTable = React.lazy(() => import("../components/AssetTable"));

const chartHeaderStyles =
  "flex flex-row justify-between items-center mb-2 mt-2 h-[1rem] text-xs font-bold";
const headerTextStyles = "bg-emerald-400 text-black rounded-xl pl-2 pr-2 pt-[0.2rem] pb-[0.2rem]";

const Portfolio: FC = () => {
  return (
    <View>
      <>
        <div
          id="desktop-hero"
          className="w-full h-auto flex flex-row items-center pb-6 pt-2"
        >
          <div
            id="hero-left"
            className="flex flex-col w-1/5 items-start justify-between h-full"
          >
            <div id="top-stats" className="flex flex-col justify-center flex-grow pb-10">
              <p className=" text-black font3-bold bg-white rounded-2xl p-[0.5] pl-2 pr-2 mb-3 inline-block w-[6rem]">
                Net Worth
              </p>
              <AssetValue />
            </div>
            <div id="bottom-stats">
              <div>
                <p className="text-neutral-500">24hr change</p>
                <AssetChange />
              </div>
              <div>
                <p className="text-neutral-500">Est Yearly Return</p>
                <p className="text-green-700 text-2xl">~ $325</p>
              </div>
              <div>
                <p className="text-neutral-500">Est Monthly Return</p>
                <p className="text-green-700 text-2xl">~ $27</p>
              </div>
            </div>
          </div>
          <div
            id="hero-right"
            className="flex w-4/5 grow items-center justify-center"
          >
            <div className="h-[25rem] w-full flex flex-row ">
              <div id="charts-left" className="flex flex-col w-3/4 mr-2">
                <div className={chartHeaderStyles}>
                  <p className={headerTextStyles}>
                    TOTAL ASSET WORTH
                  </p>
                  <div className="scale-75">
                    <Dropdown chart="worthLine" />
                  </div>
                </div>
                <Suspense fallback={<SkeletonLarge />}>
                  <WorthLine />
                </Suspense>
                <div className="h-[24px] w-full" />
                <div className={chartHeaderStyles}>
                  <p className={headerTextStyles}>
                    PORTFOLIO PERFORMANCE
                  </p>
                  <div className="scale-75">
                    <Dropdown chart="portLine"/>
                  </div>
                </div>
                <Suspense fallback={<SkeletonLarge />}>
                  <PortfolioLine />
                </Suspense>
              </div>
              <div
                id="charts-right"
                className="flex flex-col w-1/4 justify-center ml-2"
              >
                <div id="top-chart-right" className="h-1/2 w-full">
                  <div className={chartHeaderStyles}>
                    <p className={headerTextStyles}>
                      DAILY P&L
                    </p>
                    <div className="scale-75">
                      <Dropdown chart="dailyBar"/>
                    </div>
                  </div>
                  <div>
                    <Suspense fallback={<SkeletonLarge />}>
                      <DailyBar />
                    </Suspense>
                  </div>
                </div>
                <div className="h-[24px] w-full" />
                <div id="bottom-chart-right" className="h-1/2 w-full">
                  <div className={chartHeaderStyles}>
                    <p className={headerTextStyles}>
                      CUMULATIVE P&L
                    </p>
                    <div className="scale-75">
                      <Dropdown chart="dailyLine"/>
                    </div>
                  </div>
                  <div>
                    <Suspense fallback={<SkeletonLarge />}>
                      <DailyLine />
                    </Suspense>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="portfolio-wrapper" className="w-full h-auto min-h-0">
          <div className="w-full mb-12">
            <Suspense fallback={<SkeletonLarge />}>
              <AssetTable />
            </Suspense>
          </div>
          <div className="w-full h-[10rem]">
            {/* spacer for scrollbar to take effect */}
          </div>
        </div>
      </>
    </View>
  );
};

export default Portfolio;
